export const environment = {
    BASE_URL: 'https://staging-api.getkapay.com',
    // The "Dashboard V2" menu entry shows only where this is true (local). The page itself is open by its URL.
    showDashboardV2: false

};
